export function BlogSection() {
    let posts = document.querySelectorAll('.post');

    posts.forEach(post => {
        let defaultImg = post.querySelector('.bg-img img'),
            hoverImg = post.querySelector('.hover-img');

        post.addEventListener('mouseenter', () => {
            defaultImg.classList.toggle('hidden')
            hoverImg.classList.toggle('hidden')
        })
        post.addEventListener('mouseleave', () => {
            setTimeout(() => {
                defaultImg.classList.toggle('hidden')
                hoverImg.classList.toggle('hidden')
            }, 320)
        })
    })
}